import _ from 'lodash'
import mixpanel from 'mixpanel-browser'
import store from '@/store'

const isSit = process.env.VUE_APP_ENV !== 'production'
const isProduction = process.env.VUE_APP_ENV === 'production'
// eslint-disable-next-line max-len
const MIXPANEL_TOKEN = isProduction ? process.env.VUE_APP_MIXPANEL_TOKEN : process.env.VUE_APP_MIXPANEL_TOKEN_SIT

let isInitialized = false

function identifyUser() {
  try {
    if (_.has(window, 'sessionStorage')) {
      if (window.sessionStorage.getItem('Mixpanel_HasIdentified')) {
        return
      }
    }

    const accountUuid = store.state.account.userInfo.account_uuid

    if (isSit) {
      console.log('Mixpanel identify: ', accountUuid); // eslint-disable-line
    }

    mixpanel.identify(accountUuid)
    window.sessionStorage.setItem('Mixpanel_HasIdentified', 1)
  } catch (e) {
    console.warn('ERROR - Mixpanel identify: ', e)
  }
}

function setSuperProperties() {
  try {
    const superProperties = {
      Platform: 'kkpartners.kkday.com',
      DisplayLang: localStorage.getItem('lang') || 'en'
    }

    if (isSit) {
      console.log('SuperProperty: ', superProperties); // eslint-disable-line
    }

    mixpanel.register(superProperties)
  } catch (e) {
    console.warn('ERROR - SuperProperty: ', e)
  }
}

function setPeopleProperties() {
  try {
    if (_.has(window, 'sessionStorage')) {
      if (window.sessionStorage.getItem('Mixpanel_HasPeopleSet')) {
        return
      }
    }

    const accountUuid = store.state?.account?.userInfo?.account_uuid
    const email = store.state?.account?.userInfo?.email
    const affiliateUuid = store.state?.account?.userInfo?.affiliate?.affiliate_uuid

    const peopleProperty = {
      Platform: 'kkpartners.kkday.com',
      DisplayLang: localStorage.getItem('lang') || '',
      AccountUuid: accountUuid || '',
      AccountEmail: email || '',
      AffiliateUuid: affiliateUuid || ''
    }

    if (isSit) {
      console.log('PeopleSet: ', peopleProperty); // eslint-disable-line
    }

    mixpanel.people.set(peopleProperty)
    window.sessionStorage.setItem('Mixpanel_HasPeopleSet', 1)
  } catch (e) {
    console.warn('ERROR - PeopleSet: ', e)
  }
}

export function mixpanelSetAlias(accountUuid) {
  try {
    if (isSit) {
      console.log('Mixpanel alias: ', accountUuid); // eslint-disable-line
    }
    mixpanel.alias(accountUuid)
  } catch (e) {
    console.warn('ERROR - Mixpanel alias: ', e)
  }
}

export function mixpanelInit() {
  mixpanel.init(MIXPANEL_TOKEN)
  window.mixpanel = mixpanel
  setSuperProperties()
  isInitialized = true
}

export function mixpanelInitUserLogin() {
  identifyUser()
  setPeopleProperties()
}

export function mixpanelReset() {
  mixpanel.reset()
  window.sessionStorage.removeItem('Mixpanel_HasIdentified')
  window.sessionStorage.removeItem('Mixpanel_HasPeopleSet')
}

export function mixpanelTrack(name, data = {}) {
  if (!isInitialized) {
    return
  }
  if (!localStorage.getItem('extraChannel') === 'KKPARTNERS') {
    return
  }
  try {
    data.KKday_member_uuid = store.state.account?.userInfo?.affiliate?.kkday_member_uuid
    if (isSit) {
      console.group(name)
      console.table(data)
      console.groupEnd()
    }
    mixpanel.track(name, data)
  } catch (e) {
    console.warn(`ERROR - : ${name}`, e)
  }
}
